import memberLoginFormTemplate from './member_login_form.html';
import memberLoginSchemaFormTemplate from './member_login_schema_form.html';

function MemberLoginCtrl($scope, $rootScope, halClient, BBModel, AlertService, ValidatorService, LoadingService) {
    'ngInject';

    $scope.login = {};

    $scope.validator = ValidatorService;

    const loader = LoadingService.$loader($scope).notLoaded();

    $scope.passInputType = 'password';
    $scope.showHideClass = true;

    $rootScope.connection_started.then(() => {

        if (BBModel.Login.$checkLogin()) {
            $scope.setClient($rootScope.member);
            if ($scope.bb.destination) {
                return $scope.redirectTo($scope.bb.destination);
            } else {
                loader.setLoaded();
                $scope.skipThisStep();
                return $scope.decideNextPage();
            }
        } else {
            return halClient.$get(`${$scope.bb.api_url}/api/v1`).then(root =>
                root.$get('new_login').then((new_login) => {
                    $scope.form = new_login.form;
                    $scope.schema = new_login.schema;
                    return loader.setLoaded();
                }, err => console.log('err ', err))
                , err => console.log('err ', err));
        }
    });

    $scope.togglePassword = function () {
        $scope.passInputType = ($scope.passInputType == 'password' ? 'text' : 'password');
        $scope.showHideClass = ($scope.showHideClass ? false : true);
    }

    $scope.submit = function () {

        $scope.login.role = 'member';

        loader.notLoaded();

        return $scope.bb.company.$post('login', {}, $scope.login).then((login) => {
            if (login.$has('members')) {
                return login.$get('members').then(members => $scope.handleLogin(members[0]));
            } else if (login.$has('member')) {
                return login.$get('member').then(member => $scope.handleLogin(member));
            }
        }, (err) => {
            loader.setLoaded();
            if (err.data.error === 'Account has been disabled') {
                return AlertService.raise('ACCOUNT_DISABLED');
            } else {
                return AlertService.raise('LOGIN_FAILED');
            }
        });
    };


    $scope.handleLogin = function (member) {
        member = BBModel.Login.$setLogin(member, $scope.login.persist_login);
        $scope.setClient(member);

        loader.setLoaded();
        if ($scope.bb.destination) {
            return $scope.redirectTo($scope.bb.destination);
        } else {
            $scope.skipThisStep();
            return $scope.decideNextPage();
        }
    };
}

function MemberLoginDirective() {
    return {
        restrict: 'A',
        controller: MemberLoginCtrl,
        templateUrl(elem, attrs) {
            if (attrs.bbCustomLoginForm != null) {
                return memberLoginFormTemplate.id;
            } else {
                return memberLoginSchemaFormTemplate.id;
            }
        }
    };
}

angular
    .module('BlMember')
    .directive('blMemberLogin', MemberLoginDirective);


// WEBPACK FOOTER //
// ../src/public/javascripts/member-login/member_login.directive.js